module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XV4ust/tc-custom/9780544785878.jpg?1701476988033",
      "alt": "This image is the cover for the book Curious George Subway Train Adventure, CGTV Reader"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Curious George Subway Train Adventure, CGTV Reader\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Can George find his way to the zoo all by himself? A storybook based on the beloved PBS series starring everyone’s favorite monkey.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this Level 2 Green Light Reader based on the Emmy Award-winning PBS show, George can’t believe his luck when he gets to visit the zoo and ride there on the subway! George is so excited to take the underground train for the first time that he jumps right on, leaving the man with the yellow hat behind in the terminal!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Can George maneuver the speedy subway in order to find his friend—and get to the zoo? This subway adventure teaches the basics of reading a map, understanding different directions of travel, and problem-solving, and also includes bonus activities to help reinforce those concepts.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H.A. Rey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0